import { always, assocPath, compose } from 'ramda';
import { handleActions } from 'redux-actions';

import { EMPTY_VALUES } from 'constants/general';
import { getTodayAsIso } from 'utils/apiDateTime';

import * as types from './actionTypes';

const initialState = {
	semaphoreRecords: EMPTY_VALUES.ARRAY,
	recordsFeedback: EMPTY_VALUES.OBJECT,
	semaphoreInfoGraphics: EMPTY_VALUES.OBJECT,
};

const setFeedback = (state, { payload }) => {
	let finalFeedbackValue;
	const recordId = payload.recordId;
	const previousFeedback = state?.recordsFeedback[recordId];
	if (previousFeedback === payload.feedbackStateId) {
		finalFeedbackValue = EMPTY_VALUES.STRING;
	} else {
		finalFeedbackValue = payload.feedbackStateId;
	}

	return {
		...state,
		recordsFeedback: {
			...state.recordsFeedback,
			[payload.recordId]: finalFeedbackValue,
		},
	};
};

const updateSemaphoreRecord = (state, { payload }) => {
	const { path, updatedValue, partnerId } = payload;
	let result;
	const updatedRecords = state.semaphoreRecords.map((record) => {
		if (record.partnerId === partnerId) {
			// updating value and then time of last modification locally
			result = compose(assocPath([path[0], 'date'], getTodayAsIso()), assocPath(path, updatedValue))(record);
			return result;
		} else {
			return record;
		}
	});

	return {
		...state,
		semaphoreRecords: updatedRecords,
	};
};

const resetFeedbacks = (state) => {
	return {
		...state,
		recordsFeedback: EMPTY_VALUES.OBJECT,
	};
};

const revertFeedback = (state, { payload }) => {
	return {
		...state,
		recordsFeedback: {
			...state.recordsFeedback,
			[payload.recordId]: payload.originalFeedbackId,
		},
	};
};

const appendSemaphoreList = (state, { payload }) => {
	return {
		...state,
		semaphoreRecords: [...state.semaphoreRecords, ...payload.values],
	};
};

const setSemaphoreList = (state, { payload }) => {
	return {
		...state,
		semaphoreRecords: payload.values,
	};
};

const setSemaphoreDashboard = (state, { payload }) => {
	return {
		...state,
		semaphoreInfoGraphics: payload.result,
	};
};

const semaphoreReducerMap = {
	[types.SET_FEEDBACK]: setFeedback,
	[types.REVERT_FEEDBACK]: revertFeedback,
	[types.UPDATE_SEMAPHORE_RECORD]: updateSemaphoreRecord,
	[types.RESET_FEEDBACKS]: resetFeedbacks,
	[types.APPEND_SEMAPHORE_LIST]: appendSemaphoreList,
	[types.SET_SEMAPHORE_LIST]: setSemaphoreList,
	[types.SET_SEMAPHORE_DASHBOARD]: setSemaphoreDashboard,
	[types.RESET_REDUCER]: always(initialState),
};

export default handleActions(semaphoreReducerMap, initialState);
